
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/siber-guvenlik-kanunu",
      function () {
        return require("private-next-pages/compliance/siber-guvenlik-kanunu.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/siber-guvenlik-kanunu"])
      });
    }
  